module.exports = __webpack_public_path__ + "fonts/font_3291488_ssc0i5si4es.ba939052.woff2";